var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "upload-01"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M16.5312 12.3438V13.2812C16.5312 14.5939 16.5312 15.2502 16.2758 15.7515C16.0511 16.1925 15.6925 16.5511 15.2515 16.7758C14.7502 17.0312 14.0939 17.0312 12.7812 17.0312H6.21875C4.90613 17.0312 4.24982 17.0312 3.74846 16.7758C3.30745 16.5511 2.94891 16.1925 2.7242 15.7515C2.46875 15.2502 2.46875 14.5939 2.46875 13.2812V12.3438M13.4062 6.875L9.5 2.96875M9.5 2.96875L5.59375 6.875M9.5 2.96875V12.3438",
    stroke: "#6C737F",
    strokeWidth: 1.5625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadIcon);
export default __webpack_public_path__ + "static/media/uploadIcon.c275157da93a3244ea74e29f36e02f4a.svg";
export { ForwardRef as ReactComponent };